<div class='about'
  [ngClass]="this.resLayout">

  <!-- MCP Announcement Banner -->
  <section class="mcp-hero">
    <div class="mcp-hero-content">
      <h2 class="mcp-hero-title">Turn Power Automate into an AI Agent Platform</h2>
      <p class="mcp-hero-subtitle">Introducing FlowStudio MCP — let AI agents build, deploy, debug and monitor your Power Automate flows. Already a FlowStudio customer? MCP is included in your bundle, so jump in and try it today.</p>
      <div class="mcp-hero-actions">
        <a href="https://mcp.flowstudio.app" target="_blank" rel="noopener noreferrer" (click)="$event.stopPropagation()"
          class="k-button k-button-md k-rounded-md mcp-btn-primary">
          Try MCP
        </a>
        <button type="button" (click)="this.toggleMcpVideo($event)"
          class="k-button k-button-md k-rounded-md mcp-btn-outline"
          [attr.aria-expanded]="this.showMcpVideo"
          aria-controls="mcp-video-panel">
          {{ this.showMcpVideo ? 'Hide 30 second video' : 'Show 30 second video' }}
        </button>
      </div>
      <div id="mcp-video-panel" class="mcp-video-panel" [class.open]="this.showMcpVideo">
        <div class="mcp-video-inner">
          <video #mcpHeroVideo class="mcp-hero-video" controls playsinline preload="metadata">
            <source src="https://mcp.flowstudio.app/website-hero-v2.mp4" type="video/mp4" />
          </video>
        </div>
      </div>
    </div>
  </section>

  <!-- Hero Section -->
  <section class="hero-section">
    <div class="hero-inner">
      <!-- <div class="hero-badge">
      <i class="ms-Icon ms-Icon--LightningBolt" aria-hidden="true"></i>
      New: MCP for Power Automate
    </div> -->
    <h1 class="hero-heading">
      Know When Power Automate Breaks —
      <span class="hero-heading-gradient">Before the Business Feels It</span>
    </h1>
    <p class="hero-lead">
      FlowStudio provides the observability and management layer Microsoft Power Automate users have been waiting for. Monitor, manage, and scale your flows with confidence.
    </p>
    <div class="hero-cta">
      @if (this.isApp() && (this.user$ | async)) {
        <button kendoButton (click)="welcomeBack($event)" class="hero-btn-primary" themeColor="primary" title="Return to FlowStudio">
          <fa-icon icon="arrow-circle-right"></fa-icon>
          Continue, {{ (this.user$ | async)?.username }}
        </button>
      }
      @if (this.isApp() && !(this.user$ | async)) {
        <button kendoButton (click)="login($event)" class="hero-btn-primary" themeColor="primary" [icon]="'user'">
          Login to FlowStudio
        </button>
      }
      @if (!this.isApp()) {
        <a href="https://prod.flowstudio.app/login" rel="noopener noreferrer" (click)="$event.stopPropagation()"
          class="k-button k-primary k-button-solid k-button-solid-primary k-button-md k-rounded-md hero-btn-primary">
          <fa-icon icon="arrow-circle-right" title="Login to FlowStudio"></fa-icon>
          Login to FlowStudio
        </a>
      }
    </div>
    <!-- Dashboard preview -->
    <div class="hero-dashboard-preview">
      <!-- <img src="/assets/flow-studio-transparency.png" alt="FlowStudio Dashboard"> -->
    </div>
  </div>
</section>

<!-- Trusted By -->
<section class="trusted-section">
  <p class="trusted-label">Trusted by forward-thinking enterprises</p>
  <div class="trusted-logos">
    <div><img src="/assets/logo/83c584c1-3a66-48ff-8dfd-eec56ebfe5e7.png" title="PepsiCo"></div>
    <div><img src="/assets/logo/dd720acf-2686-413d-bf77-4d4e4a315f5c.png" title="Microsoft"></div>
    <div><img src="/assets/logo/0c0102ca-13c4-4092-b8f8-9259e564496a.png" title=""></div>
    <div><img src="/assets/logo/3c34bc05-53ee-4092-93ec-5af366dad5be.png" title="PWC"></div>
    <div><img src="/assets/logo/3dc658af-0ce7-4434-8f3a-3a930f731cea.png" title="Tassal"></div>
    <div><img src="/assets/logo/5ff303ea-5b60-4084-ad83-02a7dc7ee3c5.png" title="SIEMENS"></div>
    <div><img src="/assets/logo/6a2912d1-1d11-4b62-b07f-d198ed2a4473.png" title="Procter & Gamble"></div>
    <div><img src="/assets/logo/6c3a59cf-a004-4367-af04-2b4c6907755c.png" title=""></div>
    <div><img src="/assets/logo/7ae8f322-2940-4dbf-ad0d-98117e993d72.png" title="Essity"></div>
    <div><img src="/assets/logo/8bba5664-5286-4e42-9a8a-de354dfb480e.png" title="DuPont"></div>
    <div><img src="/assets/logo/9ad157b8-92ac-47cb-806d-4e0b7b09a00e.png" title="JDE"></div>
    <div><img src="/assets/logo/34bcf817-d8ba-4c71-9f8d-877de2c14139.png" title=""></div>
    <div><img src="/assets/logo/68f7d31d-0934-4e9e-b28c-6ac02fcde5a4.png" title=""></div>
    <div><img src="/assets/logo/75bd91c7-6e8e-44f5-93ef-935cbdaea854.png" title="Capgemini"></div>
    <div><img src="/assets/logo/96d0542d-16c2-4bc1-9d51-b4723fe0ac5d.png" title="Stryker"></div>
    <div><img src="/assets/logo/168c2e00-e382-425f-8827-222cd5f55f73.png" title=""></div>
    <div><img src="/assets/logo/196e5d40-5a4b-43db-a95d-b81358480fba.png" title="HP"></div>
    <div><img src="/assets/logo/1563bfc0-7981-441d-adfe-3ee1acba7e7c.png" title=""></div>
    <div><img src="/assets/logo/6435b19f-4f53-43cd-a365-20a905158842.png" title=""></div>
    <div><img src="/assets/logo/82847cd7-4959-4811-98c7-868f9ccd65a9.png" title=""></div>
    <div><img src="/assets/logo/1589612511435.jfif" alt=""></div>
    <div><img src="/assets/logo/aa221591-220d-4698-80fc-b14353e0b160.png" title="Unilever"></div>
    <div><img src="/assets/logo/adbc858d-b00f-43e6-be2a-f2a517136791.png" title="ACT Government"></div>
    <div><img src="/assets/logo/bfc011e6-ce51-43e9-8af2-6735d21394b5.png" title=""></div>
    <div><img src="/assets/logo/c8178d13-65f2-4878-8177-627768f40417.png" title=""></div>
    <div><img src="/assets/logo/d11bbe31-5586-4585-9f85-2a7794e7d9d5.png" title="Johnson & Johnson"></div>
    <div><img src="/assets/logo/d11df1b9-6c9a-4bc2-9e51-220391d6dc54.png" title="NOKIA"></div>
    <div><img src="/assets/logo/d35df1ea-a54a-41a8-92ed-a24831b32975.png" title=""></div>
    <div><img src="/assets/logo/d165f4fe-6955-41a8-88b0-130e08eb5718.png" title="Lend Lease"></div>
    <div><img src="/assets/logo/d8217fa1-a2ba-4c00-ba60-49eb50f095ac.png" title=""></div>
    <div><img src="/assets/logo/d2319734-7337-4f62-8a59-2839d978df00.png" title=""></div>
    <div><img src="/assets/logo/f3dc58bf-48f0-43cb-834d-5af7748e2008.png" title="3M"></div>
    <div><img src="/assets/logo/mars_logo.svg" title="MARS"></div>
    <div><img src="/assets/logo/mcd-token-logo.svg" title="mcd"></div>
    <div><img src="/assets/logo/SLB_Logo_RGB_svg.svg" title="SLB"></div>
    <div><img src="/assets/logo/fb4e251c-bd0d-4853-aa50-11aab806501d.png" title="Mrs Macs"></div>
    <div><img src="/assets/logo/4d772b7f-d6f9-4de4-9631-f764bdd9c0aa.png" title="Intel"></div>
    <div title="and more!">...</div>
  </div>
</section>

<!-- Pricing Section -->
<section class="py-16 px-4 sm:px-6 lg:px-8 bg-[#f9fafb]">
  <div class="max-w-7xl mx-auto">
    <!-- Header -->
    <div class="text-center mb-16">
      <h2 class="text-lg font-medium text-slate-600 mb-6">Simple, transparent pricing to help you grow.</h2>
      <!-- Billing Toggle -->
      <div class="flex items-center justify-center space-x-4">
        <span class="text-sm font-medium" [style.color]="this.productYearly ? '#94a3b8' : '#475569'">Monthly</span>
        <button type="button" class="relative inline-flex items-center h-7 w-12 rounded-full border-0 cursor-pointer p-0 focus:outline-none"
          [style.background-color]="this.productYearly ? '#1E6EB7' : '#cbd5e1'"
          style="transition: background-color 0.2s ease;"
          (click)="this.productYearly = !this.productYearly">
          <span class="inline-block h-5 w-5 rounded-full bg-white shadow"
            [style.transform]="this.productYearly ? 'translateX(1.375rem)' : 'translateX(0.25rem)'"
          style="transition: transform 0.2s ease;"></span>
        </button>
        <span class="text-sm font-medium" [style.color]="this.productYearly ? '#475569' : '#94a3b8'">Yearly</span>
      </div>
    </div>
    <!-- Pricing Grid -->
    <div class="grid grid-cols-1 md:grid-cols-3 gap-8 items-stretch">
      <!-- Free Plan -->
      <section class="bg-white border border-slate-200 rounded-lg p-8 flex flex-col shadow-sm">
        <div class="mb-8">
          <span class="text-brand font-bold text-xs tracking-widest uppercase">Individual</span>
          <h3 class="text-4xl font-bold mt-2 text-slate-900">Free</h3>
          <p class="text-slate-600 mt-2 text-sm leading-relaxed">For makers tracking their first workflows.</p>
        </div>
        <div class="mb-8 flex items-baseline">
          <span class="text-4xl font-bold text-slate-900">$0</span>
          <span class="text-slate-500 text-sm ml-1">/forever</span>
        </div>
        <div class="mb-10 flex-grow">
          <app-about-fs-free></app-about-fs-free>
        </div>
        @if (this.isApp() && !(this.user$ | async)) {
          <button (click)="login($event)"
            class="w-full py-3 px-4 border border-brand bg-white text-brand font-semibold rounded-lg hover:bg-brand hover:text-white transition-colors"
            >
            Get Started
          </button>
        }
        @if (this.isApp() && (this.user$ | async)) {
          <button (click)="welcomeBack($event)"
            class="w-full py-3 px-4 border border-brand bg-white text-brand font-semibold rounded-lg hover:bg-brand hover:text-white transition-colors"
            >
            Continue
          </button>
        }
        @if (!this.isApp()) {
          <a href="https://prod.flowstudio.app/login" rel="noopener noreferrer" (click)="$event.stopPropagation()"
            class="w-full py-3 px-4 border border-brand bg-white text-brand font-semibold rounded-lg hover:bg-brand hover:text-white transition-colors text-center block"
            >
            Login to FlowStudio
          </a>
        }
      </section>

      <!-- Pro Plan (Featured) -->
      <section class="relative bg-white border-4 border-brand rounded-lg p-8 flex flex-col shadow-xl z-10 md:scale-105">
        <!-- Badge -->
        <div class="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-brand text-white text-[10px] font-bold tracking-widest uppercase py-1 px-4 rounded-full">
          Most Popular
        </div>
        <div class="mb-8">
          <span class="text-brand font-bold text-xs tracking-widest uppercase">Pro Maker</span>
          <h3 class="text-4xl font-bold mt-2 text-slate-900">Pro</h3>
          <p class="text-slate-600 mt-2 text-sm leading-relaxed">Advanced monitoring for professional developers.</p>
        </div>
        <div class="mb-8 flex items-baseline">
          @if (!this.productYearly) {
            <span class="text-4xl font-bold text-slate-900">${{this.constants.pro_monthly}}</span>
          }
          @if (this.productYearly) {
            <span class="text-4xl font-bold text-slate-900">${{this.constants.pro_yearly}}</span>
          }
          <span class="text-slate-500 text-sm ml-1">{{this.productYearly ? '/year' : '/month'}}</span>
        </div>
        <div class="mb-10 flex-grow">
          <app-about-fs-pro></app-about-fs-pro>
        </div>
        @if (this.isApp()) {
          <button (click)="this.buy('pro');$event.stopPropagation();"
            class="w-full py-3 px-4 bg-brand text-white font-semibold rounded-lg hover:bg-brand-dark transition-colors border-0"
            >
            Upgrade to Pro
          </button>
        }
        <a href="https://learn.flowstudio.app" target="learn" (click)="$event.stopPropagation()"
          class="text-sm font-semibold text-brand hover:underline text-center mt-3 block">
          Learn More
        </a>
      </section>

      <!-- Teams Plan -->
      <section class="bg-white border border-slate-200 rounded-lg p-8 flex flex-col shadow-sm">
        <div class="mb-8">
          <span class="text-brand font-bold text-xs tracking-widest uppercase">Enterprise</span>
          <h3 class="text-4xl font-bold mt-2 text-slate-900">Teams</h3>
          <p class="text-slate-600 mt-2 text-sm leading-relaxed">Full governance for IT teams and departments.</p>
        </div>
        <div class="mb-8 flex items-baseline">
          @if (!this.productYearly) {
            <span class="text-4xl font-bold text-slate-900">${{this.constants.teams_monthly}}</span>
          }
          @if (this.productYearly) {
            <span class="text-4xl font-bold text-slate-900">${{this.constants.teams_yearly}}</span>
          }
          <span class="text-slate-500 text-sm ml-1">{{this.productYearly ? '/year' : '/month'}}</span>
        </div>
        <div class="mb-10 flex-grow">
          <app-about-fs-teams></app-about-fs-teams>
        </div>
        @if (this.isApp()) {
          <button (click)="this.buy('teams');$event.stopPropagation();"
            class="w-full py-3 px-4 border border-brand bg-white text-brand font-semibold rounded-lg hover:bg-brand hover:text-white transition-colors"
            >
            Subscribe Teams
          </button>
        }
        <a href="https://learn.flowstudio.app/blog/introducing-flow-studio-for-teams-supercharge-your-power-automate-workflows" target="learn" (click)="$event.stopPropagation()"
          class="text-sm font-semibold text-brand hover:underline text-center mt-3 block">
          Learn More
        </a>
      </section>
    </div>
  </div>
</section>

<!-- Testimonials -->
<section class="testimonials-section">
  <div class="testimonials-inner">
    <div class="testimonials-header">
      <h2>Praise from the Experts</h2>
      <p>The biggest names in the Power Platform community trust FlowStudio.</p>
    </div>
    <div class="testimonials-grid">
      <div class="testimonial-card">
        <div class="testimonial-avatar">
          <img src="../../assets/charles.jpg" alt="Charles Lamanna">
        </div>
        <p class="testimonial-quote">I had seen what John wanted to build, and cannot wait to see this come to life and grow with the Power Platform.</p>
        <div class="testimonial-author">Charles Lamanna</div>
        <div class="testimonial-role">CVP, Low Code Application Platform, Microsoft</div>
      </div>
      <div class="testimonial-card">
        <div class="testimonial-avatar">
          <img src="../../assets/brian.jpg" alt="Brian Dang">
        </div>
        <p class="testimonial-quote">&#10084; tags and organization features on FlowStudio App</p>
        <div class="testimonial-author">Brian Dang</div>
        <div class="testimonial-role">Power Apps Program Manager, Microsoft</div>
      </div>
      <div class="testimonial-card">
        <div class="testimonial-avatar">
          <img src="../../assets/jon_400x400.jpg" alt="Jon Levesque">
        </div>
        <p class="testimonial-quote">In Microsoft we have TOO MANY Environments.. and I couldn't find a flow. FlowStudio took 2 seconds, scanned all my environments and found my flow!</p>
        <div class="testimonial-author">Jon Levesque</div>
        <div class="testimonial-role">Senior Power Platform Evangelist, Microsoft</div>
      </div>
    </div>
  </div>
</section>

<!-- Final CTA -->
<section class="final-cta-section">
  <div class="final-cta-inner">
    <div class="final-cta-bg-circle final-cta-bg-circle-top"></div>
    <div class="final-cta-bg-circle final-cta-bg-circle-bottom"></div>
    <h2 class="final-cta-heading">Stop guessing. Start knowing.</h2>
    <p class="final-cta-text">Join thousands of makers and IT pros who use FlowStudio to keep their business processes running smoothly.</p>
    @if (this.isApp() && !(this.user$ | async)) {
      <button kendoButton (click)="login($event)" class="final-cta-btn">
        Login to FlowStudio
      </button>
    }
    @if (this.isApp() && (this.user$ | async)) {
      <button kendoButton (click)="welcomeBack($event)" class="final-cta-btn">
        Continue to FlowStudio
      </button>
    }
    @if (!this.isApp()) {
      <a href="https://prod.flowstudio.app/login" rel="noopener noreferrer" (click)="$event.stopPropagation()"
        class="final-cta-btn">
        Login to FlowStudio
      </a>
    }
  </div>
</section>

<!-- Footer -->
@if (this.footer) {
  <div class="footer">
    <div class="footer-inner">
      John Liu, Flow Ninja, Flow Studio Solutions<br>
      ABN 82 632 928 539<br>
      <fa-icon icon="heart" style="color: #ff6358;"></fa-icon> Sydney, Australia
    </div>
  </div>
}

</div>
